import {FC} from "react";
import {Column} from "../../atoms/Layout.tsx";
import ContentArea from "../../atoms/ContentArea.tsx";
import AppBar from "../../molecules/AppBar.tsx";
import {Text} from "../../style/typography.tsx";
import UserSettingsForm from "../../templates/UserSettingsForm.tsx";
import {updateUser, UpdateUserCommand} from "../../api/user.ts";
import {useUserContext} from "../../store/userContext.ts";
import {useNavigate} from "react-router";

const UserOnboardingPage: FC = () => {
    const userContext = useUserContext();
    const navigate = useNavigate();

    const onSubmit = async (data: UpdateUserCommand) => {
        const updatedUser = await updateUser(data);
        userContext.setUser(updatedUser);
        navigate("/u/dashboard");
    }

    return <Column grow>
        <AppBar />
        <ContentArea>
            <Column gap="52">
                <Text role="heading" size="1" weight="medium">Welcome. Let's set up your account.</Text>
                <UserSettingsForm onSubmit={onSubmit}/>
            </Column>
        </ContentArea>
    </Column>
}

export default UserOnboardingPage;